<script setup>
import {computed} from "vue";

const props = defineProps({
  variant: {
    type: String,
    default: 'info',
    validator: value => [
      'info',
      'danger',
    ].includes(value),
  },
  icon: {
    type: String,
    default: 'icons/info',
  }
})

const textClass = computed(() => {
  switch (props.variant) {
    case 'danger':
      return 'tw-text-danger';
    default:
      return 'tw-text-info';
  }
});

const containerClass = computed(() => {
  switch (props.variant) {
    case 'danger':
      return 'tw-border-danger';
    default:
      return 'tw-border-info';
  }
});

</script>

<template>
  <div
    :class="[
      'tw-flex tw-flex-col tw-gap-2 tw-bg-info-100 tw-border tw-text-base tw-rounded-lg tw-px-4 tw-py-4 tw-leading-none',
      textClass,
      containerClass,
    ]"
  >
    <div class="tw-flex tw-items-center tw-gap-2">
      <svg-vue
        :icon="icon"
        :class="`tw-h-8 tw-w-8 ${textClass} tw-shrink-0`"
      />
      <span class="tw-font-bold">
        <slot name="title" />
      </span>
    </div>
    <div class="tw-flex tw-items-center tw-h-9 tw-px-4">
      <slot name="default" />
    </div>
  </div>
</template>
